/**
 * Education as part of the brand, not a separate product.
 *
 * The left half is what exists and can be opened right now; the right half is
 * the direction, clearly labelled as a direction. No course cards, no progress
 * rings, no certificates - kikik teaches by handing you a game.
 */

import { useI18n } from "../../i18n";
import { Motif } from "../art/Motif";

const TOPICS = ["science", "logic", "math", "language", "tech", "simulation", "experiment"] as const;

export interface LearnSectionProps {
  onLearn: () => void;
}

export function LearnSection({ onLearn }: LearnSectionProps) {
  const { t } = useI18n();

  return (
    <section className="section section--learn" id="learn" aria-labelledby="learn-title" data-reveal="out">
      <div className="shell learn">
        <div className="learn__head">
          <p className="eyebrow eyebrow--onink">{t("portal.learn.eyebrow")}</p>
          <h2 className="section__title section__title--onink" id="learn-title">
            {t("portal.learn.title")}
          </h2>
          <p className="section__lead section__lead--onink">{t("portal.learn.body")}</p>
        </div>

        <div className="learn__now">
          <Motif motif="flask" className="learn__art" />
          <h3 className="learn__subtitle">{t("portal.learn.now.title")}</h3>
          <p className="learn__text">{t("portal.learn.now.body")}</p>
          <button type="button" className="btn btn--primary" onClick={onLearn}>
            {t("portal.learn.now.cta")}
          </button>
        </div>

        <div className="learn__next">
          <h3 className="learn__subtitle">{t("portal.learn.next.title")}</h3>
          <ul className="topics">
            {TOPICS.map((topic) => (
              <li key={topic} className="topics__item">
                {t(`portal.learn.topic.${topic}`)}
              </li>
            ))}
          </ul>
          <p className="learn__honest">{t("portal.learn.honest")}</p>
        </div>
      </div>
    </section>
  );
}
